<template>
    <div class="product-options">
        <h3 class="product-options__title">
            {{ getMessageByLang('productOptions', 'Опции продукта') }}
        </h3>

        <ul class="product-options__list dome-lk-list">
            <li v-for="(option, index) in options" :key="option.id">
                <div class="product-options__item">
                    <div class="product-options__item__header">
                        <ProductOption :label="getMessageByLang('nameOptionText', 'Опции продукта')">
                            <Input @input="handleChangeName($event, index)" :value="option.name"
                                :placeholder="getMessageByLang('enterNameOption', 'Введите название опции')" />
                        </ProductOption>
                        <ProductOption :label="getMessageByLang('typeOption', 'Тип опции')">
                            <ComboBox :data-items="ProductOptionTypes" v-model="option.type" :allow-custom="allowCustom"
                                :text-field="'name'" :value-field="'value'" />

                        </ProductOption>
                    </div>

                    <ul class="product-options__item__points dome-lk-list">
                        <li v-for="(point, pointIndex) in option.items" :key="`${option.id}-point-${pointIndex}`">
                            <ProductPoints @delete="handleDeletePoint" :point="point" :pointIndex="pointIndex"
                                :optionIndex="index" @change="handleChangePoint" />
                        </li>
                        <li>
                            <Button @click="addPoint(index)">{{ getMessageByLang('addPointText', 'Добавить пункт')
                            }}</Button>
                        </li>
                    </ul>

                    <div class="product-options__item__footer">
                        <Button theme-color="primary" @click="handleRemoveOption(index)">
                            {{ getMessageByLang('removeOption', 'Удалить опцию') }}
                        </Button>
                    </div>
                </div>
            </li>
        </ul>

        <div class="product-options__footer">
            <Button @click="handleAddOption">{{ getMessageByLang('addPointText', 'Добавить пункт') }}</Button>
        </div>
    </div>
</template>

<script setup>
import { ref, defineExpose, defineProps } from 'vue';

import { Input } from "@progress/kendo-vue-inputs";
import { Button } from "@progress/kendo-vue-buttons";
import { ComboBox } from '@progress/kendo-vue-dropdowns';
import { ProductOptionTypes } from '@/constants/Products.js';
import { getMessageByLang } from '@/utils/translate.js';

import ProductOption from './ProductOption';
import ProductPoints from './ProductPoints.vue';

const props = defineProps({
    listOptions: {
        type: Array,
        required: false,
        default: null
    }
})


const optionsDefault = [{
    name: '',
    type: null,
    items: [
        {
            name: null,
            price: null
        }
    ]
}];

let arr = null;
if (Array.isArray(props.listOptions)) {
    console.log('start')

    arr = props.listOptions.map((item) => {
        if (item.type === 'single') {
            item.type = {
                name: getMessageByLang('single', 'Одиночный'),
                value: 'single'
            }

        } else if(item.type === 'mode_from') {
          item.type = {
            name: 'Режим От',
            value: 'mode_from'
          }

        } else {
            item.type = {
                name: getMessageByLang('multy', 'Множественный'),
                value: 'multiple'
            }
        }

        return item;
    })
}

const options = ref(arr || optionsDefault);

const handleAddOption = () => {
    options.value.push({
        name: '',
        type: null,
        items: [
            {
                name: null,
                price: null
            }
        ]
    })
}

const handleRemoveOption = (index) => {
    options.value.splice(index, 1);
}

const handleChangeName = (event, index) => {
    options.value[index].name = event.target.value;
}

const checkIsHasPoints = (optionIndex) => {
    if (Array.isArray(options.value) && options.value[optionIndex]) {
        return true;
    }

    return false;
}

const handleChangePoint = (prop) => {
    options.value[prop.optionIndex].items[prop.pointIndex] = JSON.parse(JSON.stringify(prop.data));
}

const addPoint = (optionIndex) => {
    const defaultValue = {
        name: null,
        price: null
    };

    if (checkIsHasPoints(optionIndex)) {
        if (options.value[optionIndex].items) {
            options.value[optionIndex].items.push(defaultValue);
        } else {
            options.value[optionIndex].items = [defaultValue];
        }
    }
}

const handleDeletePoint = (optionIndex, pointIndex) => {
    try {
        if (checkIsHasPoints(optionIndex)) {
            options.value[optionIndex].slice(pointIndex, 1);
        }

    } catch (err) {
        console.error(err);
        alert( this.getMessageByLang('deleteError', 'Ошибка удаления'));
    }
}

const getData = () => {
    return options.value.filter((option) => {
        if (option.id || option.name !== '') {
            return {
                ...option,
                visible: true,
                items: option.items
            }
        }
    })
}

defineExpose({
    getData
})
</script>

<style lang="scss" scoped>
.product-options {
    padding: 2rem 0;

    &__list {
        display: flex;
        flex-direction: column;
        gap: .5rem;
    }
}

.product-options__item {
    padding: 1rem;
    border: 1px solid rgba(204, 204, 204, .8);
    border-radius: 6px;
    gap: 1rem;
    display: flex;
    flex-direction: column;


    &__header {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
    }

    &__footer {
        display: flex;
        justify-content: flex-end;
    }
}

.product-options__item__points {
    display: flex;
    flex-direction: column;
    gap: .5rem;
}
</style>
